import { render, staticRenderFns } from "./list.vue?vue&type=template&id=b4d30ffa&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4d30ffa')) {
      api.createRecord('b4d30ffa', component.options)
    } else {
      api.reload('b4d30ffa', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=b4d30ffa&", function () {
      api.rerender('b4d30ffa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/xinfang/list.vue"
export default component.exports